/**
 * Advantages Slider Module
 * Initializes and manages the advantages slider functionality
 */
(function () {
	'use strict';

	// Configuration options
	const SLIDER_CONFIG = {
		slidesPerView: 'auto',
		loop: true,
		centeredSlides: true,
		initialSlide: 3,
		speed: 600,
		effect: 'slide',
		grabCursor: true,
		spaceBetween: 40,
		autoplay: {
		  delay: 4000,
		  disableOnInteraction: false,
		  pauseOnMouseEnter: true
		},
		pagination: {
			el: '.advantages-pagination',
			clickable: true
		},
		navigation: {
			nextEl: '.advantages-button-next',
			prevEl: '.advantages-button-prev'
		},
		breakpoints: {
			320: {
				slidesPerView: 'auto',
			},
			750: {
				slidesPerView: 'auto',
				spaceBetween: 63
			}
		},
		on: {
			init: function () {
				console.log('Advantages slider initialized');
			},
			slideChange: function () {
				// Add custom slide change animation logic if needed
			}
		}
	};

	/**
	 * Initialize advantages sliders
	 */
	function initAdvantagesSliders() {
		const advantagesSliders = document.querySelectorAll('.advantages__slider');

		if (!advantagesSliders || advantagesSliders.length === 0) {
			return;
		}

		advantagesSliders.forEach(function (slider) {
			try {
				// Create new Swiper instance with configuration
				const advantagesSwiper = new Swiper(slider, SLIDER_CONFIG);

				// Add event listeners for pause/resume on hover if needed
				slider.addEventListener('mouseenter', function () {
					if (advantagesSwiper.autoplay.running) {
						advantagesSwiper.autoplay.stop();
					}
				});

				slider.addEventListener('mouseleave', function () {
					if (!advantagesSwiper.autoplay.running) {
						advantagesSwiper.autoplay.start();
					}
				});
			} catch (error) {
				console.error('Error initializing advantages slider:', error);
			}
		});
	}

	// Initialize on DOM content loaded
	document.addEventListener('DOMContentLoaded', initAdvantagesSliders);
})();